<template>
  <div>
    <custom-callout
      v-for="document in data.contractDocumentHistory"
      :key="document.contractDocumentId"
    >
      <div class="row">
        <div class="col-3">
          <label class="color-gray-6 font-14">Documento:</label>
          <p class="bold">{{ document.name }}</p>
        </div>
        <div class="col-3">
          <label class="color-gray-6 font-14">Archivo:</label>
          <p class="bold">{{ document.filename }}</p>
        </div>
      </div>
      <template #edition>
        <div class="ml-2 mr-4">
          <time-line>
            <div
              v-for="(history, index) in document.history"
              :key="history.id"
              class="ml-2 mr-4"
            >
              <time-line-item class="custom-time-line">
                <template #icon>
                  <em class="radius far fa-file" />
                </template>
                <template #date>
                  <div class="text-right">
                    <span class="color-gray-6 font-12">Fecha:</span>
                    <div class="color-black font-16 font-weight-bold fulldate">
                      {{ history.date | date }}
                    </div>
                    <div class="color-black font-16 font-weight-bold hour">
                      {{ history.date | hour }}
                    </div>
                  </div>
                </template>
                <div
                  class="d-flex justify-content-between ml-3 p-3 bg-white rounded"
                >
                  <div>
                    <p class="color-black font-16 font-weight-bold">
                      Versión {{ document.history.length - index }}
                    </p>
                  </div>
                  <div>
                    <div class="color-gray-6 font-14">Archivo:</div>
                    <div class="color-black font-16">
                      {{ history.filename }}
                    </div>
                  </div>
                  <div>
                    <div class="color-gray-6 font-14">Nombre de Usuario:</div>
                    <div class="color-black font-16">
                      {{ history.userName }}
                    </div>
                  </div>
                  <div>
                    <div class="color-gray-6 font-14">Estatus:</div>
                    <div class="color-black font-16">
                      <i
                        v-if="history.statusId"
                        class="fas fa-circle"
                        :class="`color-${getColorStatus(history.statusId)}`"
                      />
                      {{ history.status }}
                    </div>
                  </div>
                </div>
              </time-line-item>
            </div>
          </time-line>
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import rpContractStatus, {
  rpContractStatusColor,
} from '@/utils/constants/rpContractStatus.js';

export default {
  name: 'ContractDocumentHistory',
  components: {
    CustomCallout,
    TimeLine,
    TimeLineItem,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    getColorStatus() {
      return (contractStatusId) => {
        const hashMap = {
          [rpContractStatus.New]: rpContractStatusColor[rpContractStatus.New],
          [rpContractStatus.Submitted]:
            rpContractStatusColor[rpContractStatus.Submitted],
          [rpContractStatus.Approved]:
            rpContractStatusColor[rpContractStatus.Approved],
          [rpContractStatus.Denied]:
            rpContractStatusColor[rpContractStatus.Denied],
          [rpContractStatus.ApprovedContractInformation]:
            rpContractStatusColor[rpContractStatus.ApprovedContractInformation],
          [rpContractStatus.DeniedContractInformation]:
            rpContractStatusColor[rpContractStatus.DeniedContractInformation],
          [rpContractStatus.Signed]:
            rpContractStatusColor[rpContractStatus.Signed],
          [rpContractStatus.ContractCanceled]:
            rpContractStatusColor[rpContractStatus.ContractCanceled],
          [rpContractStatus.ContractAmended]:
            rpContractStatusColor[rpContractStatus.ContractAmended],
        };
        return hashMap[contractStatusId ?? rpContractStatus.Unset];
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';

::v-deep .custom-time-line {
  .timeline__content--inner {
    padding: unset !important;
  }

  .icon-absolute {
    top: 20px;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }

  em.radius {
    background: map-get($colors, 'gray-2');
    color: map-get($colors, 'white');
    box-shadow: 0px 3px 6px #00000029;
  }
}
</style>
